import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: "light", // Default theme mode
  colors: {
    primary: "#3498db",
    text: "#2c3e50",
    primary_text_color: "black",
    secondary_text_color: "white",
    chip_background_color: "lightgrey",
    back_arrow_color: "blue",
    primary_gradient_start_color: "#ce7d22",
    primary_gradient_end_color: "#fffbd4",
    borderColor: "#e0e0e0",
    background: "#ffffff",
    link_color: "#3c5bfe",
    tab_bar_active: "green",
    tab_bar_inactive: "gray",
    screen_background: "#F3F2F2",
    main_icon: "red",
    normal_icon: "blue"
  },
  fontSize: {
    large: 18,
    medium: 16,
    small: 14,
  },
};

const themeValueSlice = createSlice({
  name: "themeValue",
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setThemeData(state, action) {
      const themeData = action.payload; // API Response Data

      state.colors = {
        primary: themeData.primary_color,
        text: themeData.text,
        primary_text_color: themeData.primary_text_color,
        secondary_text_color: themeData.secondary_text_color,
        primary_gradient_start_color: themeData.primary_gradient_start_color,
        primary_gradient_end_color: themeData.primary_gradient_end_color,
        chip_background_color: themeData.chip_background_color,
        back_arrow_color: themeData.back_arrow_color,
        borderColor: themeData.borderColor,
        background: themeData.background,
        link_color: themeData.link_color,
        tab_bar_active: themeData.tab_bar_active,
        tab_bar_inactive: themeData.tab_bar_inactive,
        screen_background: themeData.screen_background,
        main_icon: themeData.main_icon,
        normal_icon: themeData.normal_icon
      };

      // Update Font Sizes from API Response
      state.fontSize = {
        large: themeData.fontsize_large,
        medium: themeData.fontsize_medium,
        small: themeData.fontsize_small,
      };
      state.logourl = {
        dark_logo: themeData.dark_logo,
        light_logo: themeData.light_logo,
      };
    },
    changeThemeColor(state, action) {
      state.theme = action.payload; // Change theme manually
    },
  },
});

export const { setTheme, setThemeData, changeThemeColor } =
  themeValueSlice.actions;
export default themeValueSlice.reducer;
